import productCard from "../product/product-card";
import Slider from '../slider';
import initializeRecentlyViewed from './recentlyViewed';

// Factory function to create a slider instance
const createSliderInstance = (config) => new Slider(config);

export default (element) => {
  initializeRecentlyViewed();
  // Function to render recently viewed products
  const renderRecentlyViewedProducts = () => {
    const recentlyViewedContainer = document.querySelector('.recently-viewed-slider .swiper-wrapper');
    if (!recentlyViewedContainer) {
      return;
    }

    const currentlyViewedProductId = '{{ product.id }}'; // Get the current product ID from Liquid
    const recentlyViewed = JSON.parse(localStorage.getItem('recentlyViewed')) || [];

    recentlyViewedContainer.innerHTML = ''; // Clear the container

    // Filter out the currently viewed product
    const filteredRecentlyViewed = 
    recentlyViewed.filter(product => product.id !== currentlyViewedProductId);

    // Render the filtered products
    filteredRecentlyViewed.forEach(product => {
      const imgSrc = product.image || '/path/to/default/image.jpg'; // Fallback image URL
      const title = product.title || 'Unknown Product'; // Fallback title
      const color = product.color || 'Unknown Color'; // Fallback color
      const price = product.price ? `$${parseFloat(product.price).toFixed(0)}` : 'Unknown Price'; // Format price without cents
      

      recentlyViewedContainer.innerHTML += 
        `<div class='swiper-slide'>
          <a href='${product.url}'>
            <img src='${imgSrc}' alt='${title}' />
            <h3>${title}</h3>
            <p class="product-color">${color}</p>
            <p class="product-price">${price}</p>
          </a>
        </div>`;
    });
    initSlider();
  };

  // Function to initialize the slider
  const initSlider = () => {
    productCard();
    const recentlyViewedSlider = element.querySelector('[data-recently-viewed-slider]');
    if (!recentlyViewedSlider) {
      return;
    }

    const prevEl = element.querySelector('[data-recently-viewed-prev]');
    const nextEl = element.querySelector('[data-recently-viewed-next]');
    const paginationEl = element.querySelector('[data-recently-viewed-pagination]');

    // Call the factory function to create the slider instance
    createSliderInstance({
      el: recentlyViewedSlider,
      options: { 
        slidesPerView: 2,
        keyboard: true,
        spaceBetween: 10,
        mousewheel: {
          enabled: true,
          forceToAxis: true,
        },
        navigation: {
          nextEl,
          prevEl,
        },
        pagination: { 
          el: paginationEl,
          clickable: true,
        },
        breakpoints: {
          745: {
            slidesPerView: 4,
            spaceBetween: 10,
          }
        },
      },
    });
  };

  // Use MutationObserver to observe when the DOM changes and product data is available
  document.addEventListener('DOMContentLoaded', () => {
    const observer = new MutationObserver((mutations, observerInstance) => {
      const productId = '{{ product.id }}';
      const productTitle = '{{ product.title }}';

      if (productId && productId !== 'null' && productId !== '' &&
          productTitle && productTitle !== 'null' && productTitle !== '') {
        // Product data is available, observer can disconnect
        observerInstance.disconnect();
      }
    });

    // Start observing the body or a specific element for changes
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });

  // Render recently viewed products
  renderRecentlyViewedProducts();
};